export const createKeyedSingleFlight = <T>() => {
  const pendingByKey = new Map<string, Promise<T>>()

  return (key: string, operation: () => Promise<T>): Promise<T> => {
    const pending = pendingByKey.get(key)
    if (pending) {
      return pending
    }

    const next = operation().finally(() => {
      if (pendingByKey.get(key) === next) {
        pendingByKey.delete(key)
      }
    })

    pendingByKey.set(key, next)
    return next
  }
}
